import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const MoveToLayoutingWarningModal = ({
  show,
  onClose,
  problematicOrderPositions,
  selectedPositionIds,
  setSelectedPositionIds,
  onConfirm, // 👈 новое название пропса вместо startDownload
}) => {
  const problematicCount = problematicOrderPositions?.length || 0;
  const hasProblems = problematicCount > 0;

  const handleContinue = () => {
    // исключаем проблемные позиции
    const idsToRemove = (problematicOrderPositions || []).map((p) => p.id);
    const newSelected = selectedPositionIds.filter((id) => !idsToRemove.includes(id));

    // снимаем выделение с проблемных
    setSelectedPositionIds(newSelected);
    onClose();

    // вызываем подтверждённое действие (например, moveToLayouting)
    onConfirm(newSelected);
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Передача на компоновку</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {hasProblems ? (
          <>
            <p className="mb-2">
              ⚠️ Следующие позиции не могут быть переданы на компоновку,
              так как у них отсутствует товар или макет:
            </p>
            <textarea
              className="form-control mb-3"
              readOnly
              rows={Math.min(problematicCount, 10)}
              value={problematicOrderPositions.map((p) => `${p.article} — ${p.name}`).join('\n')}
            />
            <p>
              Они будут исключены из передачи. Продолжить с остальными ({selectedPositionIds.length - problematicCount}) позициями?
            </p>
          </>
        ) : (
          <p>Подтвердить передачу выбранных позиций на компоновку?</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Отмена
        </Button>
        <Button variant="primary" onClick={handleContinue}>
          Продолжить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveToLayoutingWarningModal;
